module.exports = __webpack_public_path__ + "img/imagen6.48cc09b7.png";